<template>
  <div class="fiex">
    <el-tooltip class="item" effect="dark" content="查看" placement="left">
      <a class="check" v-if="checkFlag" @click="checkClick"><i class="iconfont"><img src="@/static/icon/attention.svg"></i></a>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="修改" placement="left">
      <a class="edit" v-if="editFlag" @click="editClick"><i class="iconfont"><img src="@/static/icon/edit.svg"></i></a>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="保存" placement="left">
      <a class="save" v-if="saveFlag" @click="saveClick"><i class="iconfont"><img src="@/static/icon/save.svg"></i></a>
    </el-tooltip>
    <a class="top"><i class="iconfont"><img src="@/static/icon/top.svg"></i></a>

  </div>
</template>

<script>
export default {
  name: "h-float-icon",
  props:{
    editFlag:{
      type:Boolean,
      default:false,
    },
    checkFlag:{
      type:Boolean,
      default:false,
    },
    saveFlag:{
      type:Boolean,
      default:false,
    },
  },
  mounted() {
    this.getTop();
  },
  methods: {
    /**
     * 保存事件触发
     */
    saveClick(){
      this.$emit("saveClick");
    },
    /**
     * 查看事件触发
     */
    checkClick(){
      this.$emit("checkClick");
    },
    /**
     * 修改事件触发
     */
    editClick(){
      this.$emit("editClick");
    },
    /**
     * 返回顶部
     */
    getTop() {
      let arrows = document.querySelector(".fiex .top")
      arrows.onclick = function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }
    }
  }
}
</script>

<style scoped>

.fiex {
  position: fixed;
  bottom: 50px;
  right: 30px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.fiex a {
  margin: 10px 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 1s;
  background-color: #fff;
  cursor: pointer;
}

/*.fiex .iconfont {
  width: 20px;
  height: 20px;
}*/

.fiex .pen:hover {
  background-color: #fd281a;
}

.fiex .pen:hover i {
  color: #fff;
}

.fiex .top:hover i {
  color: #9f9f9f;
}
</style>
